import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export interface FeaturedReview {
  reviewId: number
  rating: number
  feedbackText: string
  reviewerPosition?: string
  reviewerTitle?: string
  hospital: {
    id: number
    name: string
    permalink: string
    city?: string
    state?: string
  }
}

export interface FeaturedReviewsResponse {
  reviews: FeaturedReview[]
  refreshedAt: string | null
}

export class FeaturedReviewsService {
  public async getFeaturedReviews(): Promise<FeaturedReviewsResponse> {
    const service = new ScrubstrApiQueryService()
    const response = await service.get<FeaturedReviewsResponse>({
      endpoint: 'reviews/featured',
    })
    return response ?? { refreshedAt: null, reviews: [] }
  }
}
